export default __webpack_public_path__ + "static/service-managed-de8e503f7d624617f68b8115a3606190.jpg";